import React, {useRef, useEffect, useCallback} from 'react';
import './index.css';
import ReactPlayer from 'react-player';
import PropTypes from 'prop-types';
import screenfull from 'screenfull';
import {findDOMNode} from 'react-dom';

export default function VideoPlayer({
  videoUrl,
  videoCover,
  autoPlay = false,
  fullscreen = false,
  onCloseFullscreen = () => {},
}) {
  const doPlay = !!videoCover || autoPlay;
  const playerRef = useRef(null);
  const onScreenfullChange = useCallback(() => {
    if (!screenfull.isFullscreen) onCloseFullscreen();
  }, [onCloseFullscreen]);

  useEffect(() => {
    screenfull.enabled && screenfull.on('change', onScreenfullChange);
    if (
      fullscreen &&
      screenfull.enabled &&
      !screenfull.isFullscreen &&
      playerRef &&
      playerRef.current
    )
      screenfull.request(findDOMNode(playerRef.current));
    return () => {
      screenfull.enabled && screenfull.off('change');
    };
  });

  return (
    <div className="video-player-wrapper">
      <ReactPlayer
        className="video-player-block"
        url={videoUrl}
        light={videoCover || false}
        playing={doPlay}
        autoPlay={doPlay}
        controls
        width="100%"
        height="100%"
        ref={playerRef}
      />
    </div>
  );
}

VideoPlayer.propTypes = {
  videoUrl: PropTypes.string.isRequired,
  videoCover: PropTypes.string,
  autoPlay: PropTypes.bool,
  fullscreen: PropTypes.bool,
  onCloseFullscreen: PropTypes.func,
};
